import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import * as S from './styles';
/**
 * Componente Divider do Design System OLX
 */
export const Divider = props => React.createElement(S.DividerWrapper, Object.assign({
  "data-ds-component": "DS-Divider"
}, props));